import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import { verifyForgot } from "./authenticationAPI";

const VerifyForgotPassword = () => {
    const navigate = useNavigate();
      const [searchParams] = useSearchParams();
      const [error, setError] = useState<string | null>(null);
      const [loading, setLoading] = useState(true);
    
      useEffect(() => {
        const VerifyForgotPassword = async () => {
          const token = searchParams.get("token");
          if (!token) {
            setError("Invalid verification link.");
            setLoading(false);
            return;
          }
      
          try {
            const response = await verifyForgot(token);
      
            if (response.status === 200 && response.data.data) {
              localStorage.setItem("token", response.data.data.token);
              navigate(all_routes.dealsDashboard);
            } else {
              setError("Verification failed. Please try again.");
            }
          } catch (err) {
            setError("Verification error. Link may have expired.");
            console.error("Verification error:", err);
          }
      
          setLoading(false);
        };
        VerifyForgotPassword();
  }, [searchParams, navigate]);

    return (
        <div className="account-content">
            <div className="d-flex flex-wrap w-100 vh-100 overflow-hidden account-bg-03">
                <div className="d-flex align-items-center justify-content-center flex-wrap vh-100 overflow-auto p-4 w-50 bg-backdrop">
                    <div className="text-center">
                        {loading ? (
                            <h4>Verifying reset link...</h4>
                        ) : error ? (
                            <p className="text-danger">{error}</p>
                        ) : (
                            <p className="text-success">Verification successful! Redirecting...</p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VerifyForgotPassword;
